"use client"
import { HeaderNavBar } from "@/components/generic/HeaderNavBar/HeaderNavBar"
import { SideNavBar } from "@/components/generic/SideNavBar/SideNavBar"
import { cn } from "@/lib/utils"
import { usePathname } from "next/navigation"
import { useMemo, type ReactNode } from "react"

const FULLSCREEN_PATHS = ["/login", "/recover-password", "/sequences"]

export function ChildrenLayout({
  children,
  isDJUI,
  classNames,
}: {
  children: ReactNode
  isDJUI?: boolean
  classNames?: {
    root?: string
  }
}) {
  const pathname = usePathname()

  const FULLSCREEN_EXACT_EXCLUDE_PATHS = useMemo(() => {
    return [
      "/sequences/library",
      ...(isDJUI ? ["/login", "/recover-password"] : []),
    ]
  }, [isDJUI])

  const isFullscreen = useMemo(() => {
    let _isFullscreen = false

    if (FULLSCREEN_EXACT_EXCLUDE_PATHS.includes(pathname)) {
      return false
    }

    for (const path of FULLSCREEN_PATHS) {
      if (pathname.startsWith(path)) {
        _isFullscreen = true
        break
      }
    }

    return _isFullscreen
  }, [FULLSCREEN_EXACT_EXCLUDE_PATHS, pathname])

  return (
    <div
      className={cn(
        isFullscreen ? "" : "grid grid-cols-[56px_1fr] grid-rows-[64px_1fr]",
        classNames?.root
      )}
    >
      {isFullscreen ? null : (
        <>
          <div className="col-span-5">
            <HeaderNavBar />
          </div>
          <div className="row-span-4 row-start-2">
            <SideNavBar />
          </div>
        </>
      )}
      <div
        className={cn(
          "overflow-hidden",
          isFullscreen
            ? ""
            : "col-span-4 row-span-4 row-start-2 bg-r-blue dark:bg-r-blue-dark-mode"
        )}
      >
        <div
          className="size-full overflow-hidden bg-r-back-white dark:bg-r-back-white-dark-mode"
          style={{
            borderTopLeftRadius: isFullscreen ? 0 : "1rem",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
